// extracted by mini-css-extract-plugin
module.exports = {"footer-height":"96px","mobile-breakpoint-1":"1140px","mobile-breakpoint-2":"900px","mobile-breakpoint-3":"700px"};